// extracted by mini-css-extract-plugin
export default {"imgContainer":"imgContainer___uHJht","img":"img___Asc9g"};